<template>
    <div v-if="this.$md.mobile() !== null">
        <i class="mobile-columns-customization" @click="toggleCustomizationMenuMobile"></i>
        <div class="customization-columns-menu-wrapper-mobile" v-show="showCustomizationMenuMobile">
            <div class="header" v-bind:style="{'top': scrollOffsetY + 'px'}">
        <span @click="cancelPreset">
          <i class="close"></i>
        </span>
                <span>Customize Column</span>
                <span @click="applyColumnsPresetMobile">Save</span>
            </div>
            <div class="body">
        <span class="search-wrapper">
          <input type="text" name="search" placeholder="Search" v-model="search" v-on:keyup.enter="useSearch">
        </span>
                <div class="columns-wrapper">
                    <draggable v-model="orderedCheckedColumnsMobile" :options="{handle: '.reorder-item'}">
                        <div v-for="(column, columnIndex) in orderedCheckedColumnsMobile" :key="column.field" class="column">
                            <span>{{column.label}}</span>
                            <CCSwitchToggle :action="setColumns" :value="columnIndex" :checked="orderedCheckedColumnsMobile[columnIndex].checked"></CCSwitchToggle>
                            <span class="reorder-item"><i class="material-icons">reorder</i></span>
                        </div>
                    </draggable>
                </div>
            </div>
        </div>
    </div>
    <div v-else>
        <div v-click-outside="closePresetMenu">
      <span @click="togglePresetsMenu">
        Columns:
        <template v-if="currentPresetName">{{currentPresetName}}</template>
        <template v-else>Default</template>
        <i class="icon-dropdown"></i>
      </span>
            <div class="customization-columns-menu-wrapper" v-show="showPresetsMenu">
                <div class="presets-wrapper">
                    <div style="text-align: left; margin: 10px 10px 10px 0;">
                        <i v-if="currentPresetName == null" class="selected-preset"></i>
                        <span v-else style="padding-left: 18px;"></span>
                        <span style="padding-left: 5px;" @click="usePreset()">Default</span>
                    </div>
                    <div v-for="(presetData, presetName) in existedPresetsList" style="text-align: left;margin: 10px 10px 10px 0;">
                        <template v-if="presetData != null">
                            <i v-if="currentPresetName == presetName" class="selected-preset"></i>
                            <span v-else style="padding-left: 18px;"></span>
                            <span style="padding-left: 5px; padding-right: 15px;" @click="usePreset(presetName)">{{presetName}}</span>
                            <span style="float:right;">
                              <i class="edit-preset" style="margin-right: 10px;" @click="editPreset(presetName)"></i>
                              <i class="remove-preset" @click="removePreset(presetName)"></i>
                            </span>
                        </template>
                    </div>
                </div>
                <div class="preset-create-wrapper">
                    <span @click="toggleCustomizationMenu">Customize Columns...</span>
                </div>
                <div class="customization-menu-wrapper" v-if="showCustomizationMenu">
                    <div class="menu-preset-header">Customize Columns</div>
                    <div>
                        <div class="existed-columns-list-wrapper">
                            <div class="existed-columns-list-search">
                                <input type="text" name="search" placeholder="Search" v-model="search" v-on:keyup.enter="useSearch">
                            </div>
                            <div class="existed-columns-list">
                                <div v-for="(column, columnIndex) in filteredColumns" class="control-group" style="min-width: 200px;">
                                    <label class="control control-checkbox" v-if="column.visible || column.dynamicField">
                                        <input type="checkbox" :value="column.field" v-model="checkedColumnsIndexes[column.field]"/>
                                        {{column.label}} <span v-if="column.dynamicField"> (Partner)</span>
                                        <div class="control_indicator"></div>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="selected-columns-list-wrapper">
                            <div class="selected-columns-count">
                                <span>
                                  <b>{{orderedCheckedColumns.length}}</b> Column selected
                                </span>
                                <span @click="selectAllColumns()" class="select_all">Select all</span>
                                <span @click="clearSelectedColumns()" class="clear">Clear all</span>
                            </div>
                            <div class="selected-columns-list">
                                <draggable v-model="orderedCheckedColumns" :options="{handle: '.reorder-item'}">
                                    <div v-for="(column, columnIndex) in orderedCheckedColumns" :key="column.field" class="selected-item"
                                         v-on:mouseenter="onHover(column.field)"
                                         v-on:mouseleave="clearHover">

                                        <span class="reorder-item"><i class="reorder-item-icon"></i></span>
                                        <span class="element-label">{{ column.label }} <span v-if="column.dynamicField"> (Partner)</span></span>
                                        <span class="remove-item" @click="removeFromSelection(column.field)"><i class="remove-item-icon"></i></span>
                                        <span class="fix-column"  v-if="!column.dynamicField" @click="fixColumnInPreset(column.field)" v-show="isFixed(column.field) || isHovered(column.field)"><i class="fix-item-icon"></i></span>
                                    </div>
                                </draggable>
                            </div>
                        </div>
                        <div class="customize-columns-control-buttons-wrapper">
                            <div class="save-as-preset-wrapper">
                                <template v-if="savePreset">
                                    <div style="display: inline-block;">
                                        <label class="control control-checkbox no-hover">
                                            <input type="checkbox" v-model="savePreset">
                                            <div class="control_indicator" style="top: 0;"></div>
                                        </label>
                                    </div>
                                    <div style="display: inline-block;">
                                        <div style="font-size:14px;text-align:left;color: #4a90e2;">Save as preset</div>
                                        <input type="text" v-model="currentPresetName" class="preset-input">
                                    </div>
                                    <div class="clear"></div>
                                </template>
                                <template v-else>
                                    <label class="control control-checkbox no-hover">
                                        <input type="checkbox" v-model="savePreset">Save as preset
                                        <div class="control_indicator"></div>
                                    </label>
                                </template>
                            </div>
                            <div class="action-button-wrapper">
                                <button class="cancel-action" @click="cancelPreset">Cancel</button>
                                <button class="apply-action" @click="applyColumnsPreset">Apply</button>
                            </div>
                            <div class="clear"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import Vue from 'vue';
    import CCSwitchToggle from '@/components/common/CCSwitchToggle';
    import draggable from 'vuedraggable';
    import VueLocalStorage from 'vue-ls';
    import _ from 'lodash';

    Vue.use(VueLocalStorage, {
        namespace: 'adgroup_report__'
    });

    export default {
        name: "cc-table-customization-columns",
        components: {
            CCSwitchToggle,
            draggable
        },
        props: {
            columns: {
                type: Array,
                required: true
            },
            defaultColumns: {
                type: Array,
                required: true
            },
            namespace: {
                type: String,
                required: true
            }
        },
        data (){
            return {
                showPresetsMenu: false,
                showCustomizationMenu: false,
                showCustomizationMenuMobile: false,
                checkedColumnsIndexes: [],
                orderedCheckedColumns: [],
                orderedCheckedColumnsMobile: [],
                savePreset: false,
                currentPresetName: null,
                existedPresetsList: this.$ls.get(this.namespace + '_presetsList'),
                search: null,
                filteredColumns: [],
                fixedColumns: [],
                hoveredElement: null
            }
        },
        mounted: function(){

            let columns = [];

            if (this.columns.length)
            {
                columns = this.columns;
            }
            else
            {
                columns = this.defaultColumns;
            }

            this.orderedCheckedColumnsMobile = columns.filter(item => item.checked);
            this.orderedCheckedColumns = columns.filter(item => item.checked);
            this.filteredColumns = this.defaultColumns;

            this.checkedColumnsIndexes = columns.reduce(function(map, item){
                map[item.field] = (item.checked !== undefined ? item.checked : false);
                return map;
            }, {});

            // this.orderedCheckedColumnsMobile.forEach(item => item.checked = true);
            // this.orderedCheckedColumns.forEach(item => item.checked = true);

            let defaultPresetName = this.$ls.get(this.namespace + '_defaultPreset');

            if (defaultPresetName !== null)
            {
                this.usePreset(defaultPresetName, true);
            }
        },
        created: function () {
            window.addEventListener('scroll', this.onScroll);
        },
        destroyed: function () {
            window.removeEventListener('scroll', this.onScroll);
        },
        computed: {
            scrollOffsetY: function(){
                return this.$store.getters.getScrollOffsetY;
            },
            currentPreset: function(){
                return {
                    'presetName': this.currentPresetName,
                    'presetColumns': this.orderedCheckedColumns,
                    'presetColumnIndexes': this.checkedColumnsIndexes,
                    'presetFixedColumns': this.fixedColumns
                };
            },
            checkedColumns: function() {
                // let checkedColumns = _.cloneDeep(this.defaultColumns);
                //
                // if (this.checkedColumnsIndexes !== undefined && this.checkedColumnsIndexes.length)
                // {
                //     if (checkedColumns.length)
                //     {
                //         for (let item of checkedColumns)
                //         {
                //             let field = item.field;
                //
                //             if (this.checkedColumnsIndexes[field] === true)
                //             {
                //                 item.checked = true;
                //             }
                //             else
                //             {
                //                 item.checked = false;
                //             }
                //         }
                //     }
                // }
                //
                // return checkedColumns;

                return this.defaultColumns.filter(function (column, index) {
                    if (this.checkedColumnsIndexes !== undefined) {
                        if (this.checkedColumnsIndexes[column.field] == true) {
                            return true;
                        }
                    }
                    return false;
                }, this);
            },
        },
        watch: {
            checkedColumns: function(value)
            {
                if (this.orderedCheckedColumns == null)
                {
                    this.orderedCheckedColumns = value;
                }
                else
                {
                    let oldValues = this.orderedCheckedColumns.filter(item => value.includes(item));
                    let newValues = value.filter(item => !this.orderedCheckedColumns.includes(item));

                    let mergedValues = oldValues.concat(newValues);

                    mergedValues = mergedValues.sort((a, b) => {
                        return a.position - b.position;
                    });

                    this.orderedCheckedColumns = mergedValues;
                }
            },
            orderedCheckedColumnsMobile: function(value)
            {

            }
        },
        methods: {
            togglePresetsMenu: function(){
                this.showCustomizationMenu = false;
                this.showPresetsMenu = !this.showPresetsMenu;
            },
            closePresetMenu: function(){
                this.showPresetsMenu = false;
            },
            toggleCustomizationMenu: function(){
                this.showCustomizationMenu = !this.showCustomizationMenu;
                this.showCustomizationMenuMobile = !this.showCustomizationMenuMobile;
            },
            removeFromSelection: function(field){
                let index = this.orderedCheckedColumns.findIndex(item => item.field == field);
                this.$set(this.checkedColumnsIndexes, field, false);

                if (index !== -1)
                {
                    this.orderedCheckedColumns.splice(index, 1);
                }
            },
            selectAllColumns: function(){
                this.orderedCheckedColumns = this.defaultColumns;
                this.checkedColumnsIndexes = this.defaultColumns.reduce(function(map, item){
                    map[item.field] = true;
                    return map;
                }, {});
            },
            clearSelectedColumns: function(){
                this.orderedCheckedColumns = [];
                this.checkedColumnsIndexes = this.defaultColumns.reduce(function(map, item){
                    map[item.field] = false;
                    return map;
                }, {});
            },
            getPresetByName: function(presetName){
                let localStoragePresetsList = this.$ls.get(this.namespace + '_presetsList');

                if (localStoragePresetsList !== undefined && localStoragePresetsList != null)
                {
                    if (localStoragePresetsList[presetName] != null)
                    {
                        return localStoragePresetsList[presetName];
                    }
                }

                return null;
            },
            clearSelection: function(){
                this.orderedCheckedColumns = [];
                this.currentPresetName = null;
                this.checkedColumnsIndexes = this.defaultColumns.reduce(function(map, item){
                    map[item.field] = false;
                    return map;
                }, {});
            },
            cancelPreset: function(){
                // this.clearSelection();
                this.toggleCustomizationMenu();
            },
            applyColumnsPreset: function(){

                if (this.orderedCheckedColumns.length > 0 && this.currentPreset.presetColumns.length > 0)
                {
                    if (this.currentPresetName != null)
                    {
                        let localStoragePresetsList = this.$ls.get(this.namespace + '_presetsList');

                        if (localStoragePresetsList === null)
                        {
                            localStoragePresetsList = {};
                        }

                        localStoragePresetsList[this.currentPresetName] = this.currentPreset;

                        this.$ls.set(this.namespace + '_defaultPreset', this.currentPresetName);
                        this.$ls.set(this.namespace + '_presetsList', localStoragePresetsList);
                        this.updatePresetsList(localStoragePresetsList);

                        this.savePreset = false;
                    }

                    this.$store.dispatch(this.namespace + '/setReportColumns', this.orderedCheckedColumns);
                    this.$store.dispatch(this.namespace + '/setFixedColumns', this.fixedColumns);
                    this.$store.dispatch(this.namespace + '/startLoading');
                    this.$store.dispatch(this.namespace + '/setUpdatingStatus', true);
                    this.toggleCustomizationMenu();
                    this.showCustomizationMenuMobile = false;
                    this.closePresetMenu();
                }
            },
            applyColumnsPresetMobile: function(){

                let columns = this.orderedCheckedColumnsMobile.filter(item => item.checked);

                this.$store.dispatch(this.namespace + '/setReportColumns', columns);
                this.$store.dispatch(this.namespace + '/setFixedColumns', this.fixedColumns);
                this.$store.dispatch(this.namespace + '/startLoading');
                this.$store.dispatch(this.namespace + '/setUpdatingStatus', true);
                this.showCustomizationMenuMobile = false;
            },
            updatePresetsList: function(presetsList){
                this.existedPresetsList = presetsList;
            },
            editPreset: function(presetName){
                let presetData = this.getPresetByName(presetName);

                if (presetData != null)
                {
                    this.checkedColumnsIndexes = presetData.presetColumnIndexes;
                    this.orderedCheckedColumns = presetData.presetColumns;
                    this.fixedColumns = presetData.presetFixedColumns;
                }

                this.savePreset = true;
                this.currentPresetName = presetData.presetName;

                this.toggleCustomizationMenu();
            },
            removePreset: function(presetName){
                let localStoragePresetsList = this.$ls.get(this.namespace + '_presetsList');
                delete(localStoragePresetsList[presetName]);
                this.$ls.set(this.namespace + '_presetsList', localStoragePresetsList);

                this.$set(this.existedPresetsList, presetName, null);
            },
            usePreset: function(presetName, disableChangingLoading = false){
                if (presetName != undefined && presetName != null)
                {
                    let presetData = this.getPresetByName(presetName);

                    if (presetData != null)
                    {
                        this.checkedColumnsIndexes = presetData.presetColumnIndexes;
                        this.orderedCheckedColumns = presetData.presetColumns;
                        this.fixedColumns = presetData.presetFixedColumns;
                    }

                    this.currentPresetName = presetData.presetName;
                    this.$store.dispatch(this.namespace + '/setReportColumns', this.orderedCheckedColumns);
                    this.$store.dispatch(this.namespace + '/setFixedColumns', this.fixedColumns);
                }
                else
                {
                    this.checkedColumnsIndexes = this.defaultColumns.reduce(function(map, item) {
                        map[item.field] = true;
                        return map;
                    }, {});
                    this.orderedCheckedColumns = [];
                    this.currentPresetName = null;

                    this.$store.dispatch(this.namespace + '/setReportColumns', this.defaultColumns);
                }

                this.$ls.set(this.namespace + '_defaultPreset', this.currentPresetName);

                this.$store.dispatch(this.namespace + '/updatePresetStatus', true);

                if (!disableChangingLoading)
                {
                    this.$store.dispatch(this.namespace + '/startLoading');
                    this.$store.dispatch(this.namespace + '/setUpdatingStatus', true);
                }
            },
            toggleCustomizationMenuMobile: function(){
                this.showCustomizationMenuMobile = !this.showCustomizationMenuMobile;
            },
            setColumns: function(status, index){
                this.$set(this.orderedCheckedColumnsMobile[index], 'checked', status);
            },
            useSearch(){
                let filteredColumns = [];

                if (this.search !== null)
                {
                    filteredColumns = this.defaultColumns.filter(function(column){
                        return  column.label.toLowerCase().includes(this.search.toLowerCase());
                    }, this);
                }
                else
                {
                    filteredColumns = this.defaultColumns;
                }


                this.filteredColumns = filteredColumns;
                this.orderedCheckedColumnsMobile = filteredColumns;
            },
            fixColumnInPreset: function(field){

                let index = this.fixedColumns.indexOf(field);

                if (index === -1)
                {
                    this.fixedColumns.push(field);
                }
                else
                {
                    this.fixedColumns.splice(index, 1);
                }
            },
            onHover: function(field){
                this.hoveredElement = field;
            },
            clearHover: function(){
                this.hoveredElement = null;
            },
            isFixed: function(field){
                if (this.fixedColumns.length > 0)
                {
                    if ((this.fixedColumns.includes(field)))
                    {
                        return true;
                    }
                }

                return false;
            },
            isHovered: function(columnIndex){

                if (this.hoveredElement == columnIndex)
                {
                    return true;
                }

                return false;
            }
        }
    }
</script>

<style lang="scss" scoped>

    .icon-dropdown {
        display: inline-block;
        width: 0.65em;
        height: 0.65em;
        margin-right: 5px;
        margin-left: 5px;
        background-image: url('/static/img/icon-dropdown-table.svg');
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        cursor: pointer;
    }

    .selected-preset {
        background-image: url('/static/img/icon-selected.svg');
        background-repeat: no-repeat;
        background-position: left center;
        background-size: contain;
        width: 12px;
        height: 12px;
        display: inline-block;
    }

    .edit-preset {
        background-image: url('/static/img/icon-edit.svg');
        background-repeat: no-repeat;
        background-position: left center;
        background-size: contain;
        width: 12px;
        height: 12px;
        display: inline-block;
    }

    .remove-preset {
        background-image: url('/static/img/icon-delete.svg');
        background-repeat: no-repeat;
        background-position: left center;
        background-size: contain;
        width: 12px;
        height: 12px;
        display: inline-block;
    }

    .customization-columns-menu-wrapper {
        position: absolute;
        background: #fff;
        z-index: 5;
        border: 1px solid #cecece;
        right: 0;
        margin-top: 10px;
        margin-right: 41px;
        min-width: 10vw;
        box-shadow: 1px 3px 7px 1px #cbcccd;

        & .presets-wrapper {
            padding: 5px 15px 5px 15px;
            border-bottom: 1px solid $border-color;

            & > div {
                cursor: pointer;
            }
        }

        & .preset-create-wrapper {
            padding: 15px;
            text-align: left;
        }
    }

    .customization-menu-wrapper {
        position: absolute;
        background: #fff;
        z-index: 5;
        border: 1px solid #cecece;
        top:0;
        right: 0;
        min-width: 30vw;
        margin-top: -1px;
        margin-right: -1px;
        box-shadow: 1px 3px 7px 1px #cbcccd;

        & > .menu-preset-header {
            text-align: left;
            padding: 10px 0 5px 10px;
            border-bottom: 1px solid #cecece;
        }
    }

    .existed-columns-list-wrapper {
        float: left;
        width: 40%;
        text-align: left;
        padding: 10px;
        border-right: 1px solid #cecece;

        & > input[type='text'] {
            width: 100%;
        }

        & > .existed-columns-list {
            max-height: 300px;
            overflow-y: scroll;

            &::-webkit-scrollbar-track
            {
                border-radius: 8px;
                background-color: #F5F5F5;
            }

            &::-webkit-scrollbar
            {
                width: 8px;
                height: 8px;
                background-color: #F5F5F5;
            }

            &::-webkit-scrollbar-thumb
            {
                border-radius: 4px;
                -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
                background-color: #868686;
                height: 55%;
            }
        }
    }

    .selected-columns-list-wrapper {
        float: left;
        width: 60%;

        & > .selected-columns-count {
            display: flex;
            justify-content: space-between;
            text-align: left;
            font-size: 14px;
            color: #797979;
            padding: 10px;
            border-bottom: 1px solid #cecece;
            flex-wrap: wrap;

            & > span.clear, & > span.select_all {
                color: #4a90e2;
                cursor: pointer;
            }
        }

        & > .selected-columns-list {

            max-height: 300px;
            overflow-y: auto;

            & .selected-item {

                & > .fix-column {

                    float: right;
                    margin-right: 15px;

                    & > .fix-item-icon {
                        display: inline-block;
                        width: 0.85em;
                        height: 0.85em;
                        background-image: url('/static/img/icon-pin.svg');
                        background-repeat: no-repeat;
                        background-position: left center;
                        background-size: contain;
                    }
                }

                & > .remove-item {

                    cursor: pointer;

                    & > .remove-item-icon {
                        display: inline-block;
                        width: 0.85em;
                        height: 0.85em;
                        background-image: url('/static/img/icon-customize-columns-close.svg');
                        background-repeat: no-repeat;
                        background-position: left center;
                        background-size: contain;
                    }
                }

                & > .reorder-item  {
                    & > .reorder-item-icon {
                        display: inline-block;
                        width: 0.85em;
                        height: 0.85em;
                        background-image: url('/static/img/icon-customize-columns-reorder.svg');
                        background-repeat: no-repeat;
                        background-position: left center;
                        background-size: contain;
                    }
                }
            }

            &::-webkit-scrollbar-track
            {
                border-radius: 8px;
                background-color: #F5F5F5;
            }

            &::-webkit-scrollbar
            {
                width: 8px;
                height: 8px;
                background-color: #F5F5F5;
            }

            &::-webkit-scrollbar-thumb
            {
                border-radius: 4px;
                -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
                background-color: #868686;
                height: 55%;
            }

            & > div > .selected-item {
                border: 1px solid #cecece;
                text-align: left;
                padding: 5px;
                margin: 5px;

                & > .reorder-item {
                    float: left;
                    cursor: pointer;

                    & > i {
                        font-size: 1.1em;
                    }

                }

                & > .remove-item {
                    float: right;

                    & > i {
                        font-size: 1.1em;
                    }

                }

                & > .element-label {
                    margin-left: 15px;
                }

            }
        }
    }

    .existed-columns-list-search {
        margin-bottom: 10px;

        & > input {
            width: 100%;
            border: 1px solid $border-color;
            border-radius: 3px;
            text-indent: 6px;
            background-image: url('/static/img/icon-search.svg');
            background-repeat: no-repeat;
            padding: 5px 15px 5px 22px;
            background-position: 4px;
            background-size: 1.5em 1em;
            font-size: 12px;
        }
    }

    .customize-columns-control-buttons-wrapper {
        clear: both;
        padding: 10px;
        border-top: 1px solid #cecece;

        & > .save-as-preset-wrapper {
            float: left;
            color: #797979;

            & > input[type="checkbox"] {
                visibility: hidden;
            }

            & .checkbox_indicator {
                position: absolute;
                top: 5px;
                left: 5px;
                height: 15px;
                width: 15px;
                background: #FFFFFF;
                border: 1px solid #979797;
                border-radius: 3px;
            }

            & .preset-input {
                border: 0;
                outline: none;
                border-bottom: 1px solid #4a90e2;
            }

        }

        & > .action-button-wrapper {
            float: right;

            & > .cancel-action {
                margin-right: 15px;
                background-color: #fff;
                border: 1px solid #dddddd;
                border-radius: 3px;
                color: #666666;
            }

            & > .apply-action {
                background-color: #4a90e2;
                border: 1px solid #3474c0;
                border-radius: 3px;
                color: #fff;
            }
        }

    }

    .control.control-checkbox {
        .control_indicator {
            border-radius: 3px;
        }

        &.no-hover {
            background: none;
        }
    }

    @media (max-width : 1280px) {
        .customization-menu-wrapper {
            min-width: 50vw;
        }
    }

    @include mobile-only {
        .mobile-columns-customization {
            display: inline-block;
            width: 2em;
            height: 2em;
            background-image: url('/static/img/icon-mobile-columns-customization.svg');
            background-repeat: no-repeat;
            background-position: left center;
            background-size: contain;
        }

        .customization-columns-menu-wrapper-mobile {
            position: absolute;
            background: #fff;
            z-index: 5;
            border: 1px solid #cecece;
            top: 0;
            left: 0;
            width: 100%;
            font-size: 1rem;
            cursor: default;

            & > .header {

                display: flex;
                justify-content: space-between;
                background: #4a90e2;
                height: 52px;
                align-items: center;
                position: sticky;
                z-index: 999;

                & > span {
                    color: #fff;

                    & > i.close {
                        display: inline-block;
                        width: 1.15em;
                        height: 1.15em;
                        background-image: url('/static/img/icon-close.svg');
                        background-repeat: no-repeat;
                        background-position: left center;
                        background-size: contain;
                    }
                }

                & > span:first-child {
                    margin-left: 15px;
                }

                & > span:last-child {
                    margin-right: 15px;
                }

            }

        }

        .body > .search-wrapper {

            margin-top: 10px;

            & > input {
                width: 100%;
                height: 40px;
                text-indent: 25px;
                border: 1px solid $border-color;
                border-radius: 3px;
                background-image: url('/static/img/icon-search.svg');
                background-repeat: no-repeat;
                background-position: 10px 12px;
                background-size: contain;
                background-size: 1em;
                padding-left: 10px;
                font-size: 0.85rem;
            }

        }

        .columns-wrapper {
            .column {
                display: grid;
                grid-template-columns: 1fr 1fr auto;
                border-bottom: 1px solid #cecece;
                padding-bottom: 10px;
                vertical-align: middle;
                padding-top: 10px;
                padding-left: 15px;
                padding-right: 15px;

                & > span:first-child {
                    margin-top: 8px;
                    text-align: left;
                }
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/reports/common/table/CCTableCustomizationColumns.vue